import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IMenuItems } from '../../../../../core/src/lib/components/menu/menu.component';

@Component({
  selector: 'app-core',
  templateUrl: './core.page.html',
  imports: [RouterModule],
})
export class CorePage {
  public readonly items: IMenuItems[] = [{ id: 'home', title: 'GLOBAL-HOME' }];
}
